export const prodServGroups = (state) => state.prodServGroups;
export const changeCategoryData = (state) => state.changeCategoryData;

